import './style/index.less';
import Favorite from './Favorite';

export default Favorite;
